import React, { useEffect, useState, createRef } from "react";
import { useNavigate } from "react-router-dom";

import http from "../services/http";
import GetStorage from "../services/Storage";
import { ToastContainer } from "react-toastify";
import { showToast } from "./ShowToast";
import storage from "../services/Storage";
import { setToken } from "../store/auth/authState";
import { setUser } from "../store/auth/user";
import { useDispatch, useSelector } from "react-redux";
import HeaderLeft from "./HeaderLeft";
import OTPInput, { ResendOTP } from "otp-input-react";
import { SpinnerCircular } from "spinners-react";

export default function Otpverification(props) {
  const craditional = useSelector((state) => state.login.craditional);
  const [OTP, setOTP] = useState("");
  const [uploadSpin, setUploadSpin] = useState(false);
  const [resendCode, setresendCode] = useState("");

  const dispatch = useDispatch();

  const ResendCode = () => {
    http.post(`public/analyst/auth`, craditional).then((res) => {
      setresendCode(res.data.token);
      showToast("success", "code has been sent");
    });
  };
  useEffect(() => {
    const token = GetStorage.get("xAuthToken");
    setresendCode(token);
  }, []);

  const navigate = useNavigate();

  const handleOtpChange = async (e) => {
    setOTP(e);
    if (e.length == 6) {
      handleSubmit(e)
    }
  }

  const handleSubmit = async (otpCode) => {
    setUploadSpin(true);
    http
      .post(`public/verify`, {
        code: otpCode,
        token: resendCode,
      })
      .then((res) => {
        // console.log("otp---->", res.data);
        setUploadSpin(false);

        const { data } = res;
        const { token, token1 } = data;
        let user = data;
        dispatch(setToken(token));
        dispatch(setUser(data));

        storage.store("xAuthToken", token);
        storage.store("xAuth", token1);
        storage.store("user", user);
        storage.store("isApproved", res.data.data.is_approved);

        const strockScreen = localStorage.getItem("screen");
        console.log("otp------>", strockScreen);

        if (strockScreen) {
          const routeArr = JSON.parse(strockScreen);
          if (routeArr[0] === "applicant/profile" && routeArr[1] !== "null") {
            navigate(`/applicant/profile/${routeArr[1]}`);
          } else {
            navigate("/welcomePersonalInfo");
          }
        } else if (res.data.data.is_approved === 1) {
          navigate("/available");
        } else {
          navigate("/welcomePersonalInfo");
        }
      })
      .catch((error) => {
        setUploadSpin(false);

        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              showToast("error", error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            showToast("error", error.response.data.message);
          }
        }
      });
  };

  return (
    <>
      <div style={{ marginTop: 20 }}>
        <HeaderLeft />
      </div>
      <section className="otp_verification">
        <div className="login_inner  pt-0">
          <h1 className="mb_30 main_title ">OTP Verification </h1>
          <p className="mb_40 them_para text-center mx-auto">
            We have sent a 6 digit OTP to your email.
            <br />
            Please enter the OTP to continue
          </p>

          <div className="otp_wraper">
            <OTPInput
              value={OTP}
              onChange={handleOtpChange}
              autoFocus
              OTPLength={6}
              otpType="number"
              inputStyles={{ width: 60, height: 60 }}
              inputClassName="otp_input"
            />
          </div>
          {/* <div className="btn_wraper">
            <button
              type="submit"
              className="them_btn mt_40 mb_30"
              onClick={handleSubmit}
            >
              {uploadSpin ? (
                <SpinnerCircular className="button-spin" />
              ) : (
                "  Continue"
              )}
            </button>
          </div> */}
          <div className="otp-resend">
            <p className="opt-receive-code">Didn't Receive Code?</p>
            <p className="otp-btn-link" onClick={ResendCode}>
              {" "}
              Resend Code
            </p>
          </div>
        </div>
      </section>
      <ToastContainer />
    </>
  );
}
